/**
 * Created by zhengyi.fu on 2018/6/4.
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
// console.log(Vue.prototype)
const testPage = [
    {
        path:"/test",
        name:"test",
        component:function (resolve) {
            require(['@/views/testCom'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "测试页面"
        }
    },
    {
        path:"/cache",
        name:"cache",
        component:function (resolve) {
            require(['@/views/other/cache'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "缓存管理"
        }
    },
    {
        path:"/freshPage",
        name:"freshPage",
        component:function (resolve) {
            require(['@/views/test/freshPage'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "页面刷新测试"
        }
    },
    {
        path:"/systemMsg",
        name:"systemMsg",
        component:function (resolve) {
            require(['@/views/test/systemMsg'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "系统信息"
        }
    },
    {
        path:"/input",
        name:"input",
        component:function (resolve) {
            require(['@/views/test/input'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "输入框信息"
        }
    },
    {
        path:"/pagelist",
        name:"pagelist",
        component:function (resolve) {
            require(['@/views/other/pageList'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "页面列表", // "页面列表"
        }
    },
    {
        path:"/errorLog",
        name:"errorLog",
        component:function (resolve) {
            require(['@/views/test/error'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "错误日志"
        }
    },
    {
        path:"/infoLog",
        name:"infoLog",
        component:function (resolve) {
            require(['@/views/test/info'],resolve)
        },
        meta:{
            requireAuth: false,
            title: "日志"
        }
    },
];
export default new Router({
    // base: '/pss/',
    mode: 'history',
    routes: [
      { path: '*', redirect: '/user' },
      { path : "/", redirect : "/user" },
      {
        path:"/user",
        name:"user",
        component:function (resolve) {
          require(['@/views/user/index'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "", // "个人中心" pages.userCenter 如果不寫title，則用上一次的title。 過渡頁面不寫title
        }
      },
      {
        path:"/home",
        name:"home",
        component:function (resolve) {
          require(['@/views/trade/home'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "home.title", // "个人中心"
        }
      },
      {
        path:"/login",
        name:"login",
        component:function (resolve) {
          require(['@/views/user/login'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "login.title", //"登录",
        }
      },
      {
        path: "/emailLogin",
        name: "emailLogin",
        component: function (resolve) {
          require(['@/views/user/emailLogin'],resolve)
        },
        meta: {
          requireAuth: false,
          title: "emailLogin.title"
        }
      },
      {
        path:"/loginSuccess",
        name:"loginSuccess",
        component:function (resolve) {
          require(['@/views/user/success'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "loginSuccess.title", // "登录成功"
        }
      },
      {
        path:"/reset",
        name:"reset",
        component:function (resolve) {
          require(['@/views/user/reset-password'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "reset.title", // "重置密码"
        }
      },
      {
        path:"/register",
        name:"register",
        component:function (resolve) {
          require(['@/views/user/register'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "register.title", // "注册"
        }
      },
      {
        path:"/machine",
        name:"machine",
        component:function (resolve) {require(['@/views/machine/index'],resolve)},
        meta:{
          requireAuth: true,
          title: "pages.myMachine", // "我的设备"
        },
        children: [
          {
            path:"/machine/binding",
            name:"binding",
            component:function (resolve) {
              require(['@/views/machine/bind-machine'],resolve)
            },
            meta:{
              requireAuth: true,
              title: "binding.title", // "绑定设备"
            }
          },
          {
            path:"/machine/binded",
            name:"binded",
            component:function (resolve) {require(['@/views/machine/success'],resolve)},
            meta:{
              requireAuth: true,
              title: "binded.title", //  "绑定成功"
            }
          },
        ]
      },
      {
        path:"/nosim",
        name:"nosim",
        component:function (resolve) {
          require(['@/views/sim/no-sim'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "noSim.title"
        }
      },
      {
        path:"/shareSimDetail",
        name:"shareSimDetail",
        component:function (resolve) {
          require(['@/views/sim/share-sim-detail'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "shareDetail.title"
        }
      },
      {
        path:"/withdraw",
        name:"withdraw",
        component:function (resolve) {
          require(['@/views/trade/withdraw-cash'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "withdraw.title"
        }
      },
      {
        path:"/withdrawRecord",
        name:"record",
        component:function (resolve) {
          require(['@/views/trade/withdraw-record'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "withdrawRecord.title"
        }
      },
      {
        path:"/historyOrder",
        name:"historyOrder",
        component:function (resolve) {
          require(['@/views/trade/history-order'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "historyOrders.title"
        }
      },
      {
        path:"/orderDetail",
        name:"orderDetail",
        component:function (resolve) {
          require(['@/views/trade/order-detail'],resolve);
        },
        meta:{
          requireAuth: true,
          title: "orderDetail.title"
        }
      },

      {
        path:"/policy",
        name:"policy",
        component:function (resolve) {
          require(['@/views/other/policy'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "policy.title"
        }
      },
      {
        path:"/agreement",
        name:"agreement",
        component:function (resolve) {
          require(['@/views/other/agreement'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "agreement.title"
        }
      },
      {
        path:"/setting",
        name:"setting",
        component:function (resolve) {
          require(['@/views/user/setting'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "setting.title"
        }
      },
      {
        path:"/changeLanguage",
        name:"changeLanguage",
        component:function (resolve) {
          require(['@/views/user/change-language'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "changeLanguage.title"
        }
      },
      {
        path:"/reservationCode",
        name:"reservationCode",
        component:function (resolve) {
          require(['@/views/user/reservation-code'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "reservationCode.title"
        }
      },
      {
        path:"/addMachine",
        name:"addMachine",
        component:function (resolve) {
          require(['@/views/machine/bind-machine'],resolve)
        },
        meta:{
          requireAuth: true,
          title: "binding.title", // "绑定设备"
        }
      },
      {
        path:"/instruction",
        name:"instruction",
        component:function (resolve) {
          require(['@/views/other/instruction'],resolve)
        },
        meta:{
          requireAuth: false,
          title: "instruction.title", // "绑定设备"
        }
      },
      ...testPage
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js